import { render, staticRenderFns } from "./real-time-screen.vue?vue&type=template&id=54279ef6&scoped=true"
import script from "./real-time-screen.vue?vue&type=script&lang=js"
export * from "./real-time-screen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54279ef6",
  null
  
)

export default component.exports